<template>
  <div class="mt-5">
    <h2 v-if="user.supplier.dash_date_activated">Bookingsystem</h2>
    <h2 v-else>Slik regnskapsføres YouWIsh</h2>
    <p v-if="user.supplier.dash_date_activated">
      Med YouWish bookingsystem kan du opprette og administrere tilgjengelige
      datoer for dine opplevelser, samt laste ned deltaker-lister selv.
    </p>
    <div v-if="user.supplier.dash_date_activated">
      <div class="d-flex justify-content-between">
        <b-button
          :to="{ name: 'bookings.new-date' }"
          variant="primary"
          size="sm"
          class="mb-2"
        >
          Legg til ny dato
        </b-button>
        <b-button-toolbar class="mb-2">
          <b-button-group class="mx-1" size="sm">
            <b-button
              :class="{ active: showType === 'calendar' }"
              @click="showType = 'calendar'"
              >Kalender</b-button
            >
            <!-- <b-button :class="{ active: showType === 'list' }" @click="showType = 'list'"
              >Liste</b-button
            > -->
          </b-button-group>
        </b-button-toolbar>
      </div>
      <booking-settings />
      <div v-if="showType === 'list'">
        <list @show-bookings="showBookingsFromList" />
      </div>

      <div class="mw-100" v-if="showType === 'calendar'">
        <calendar @show-bookings="showBookings" />
      </div>
    </div>
    <div v-else>
        <p>
            Last ned vedlegget “Slik regnskapsføres YouWish” for forklaring om fakturabilag og hvordan det føres.
        </p>
        <p>
            <a href="/yw.pdf" download>Last ned her</a>
        </p>
    </div>

    <b-modal id="bookingModal" size="lg" centered>
      <template slot="modal-title" v-if="selectedDate">
        <span
          >{{ formatDate(selectedDate.starts_at) }} -
          {{ selectedDate.variation_name }}</span
        >
        <!-- <change-participants-form :event="selectedDate" /> -->
      </template>
      <template slot="modal-footer" class="w-100" slot-scope="{ hide }">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="hide()"
        >
          Lukk
        </b-button>
      </template>
      <div v-if="selectedDate">
        <date-modal :event="selectedDate" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { format, parseISO } from "date-fns";
import { nb } from "date-fns/locale";
import Calendar from "@/components/booking/Calendar.vue";
import List from "@/components/booking/List.vue";
import DateModal from "@/components/booking/DateModal.vue";
import ChangeParticipantsForm from "@/components/booking/ChangeParticipantsForm.vue";
import BookingsSettings from "@/components/booking/Settings.vue";

export default {
  mounted() {
    this.getAvailableDates();

    if (this.$route.name === "bookings.list") {
      this.showType = "list";
    }
  },
  data() {
    return {
      showType: "calendar",
      selectedDate: null,
      rootUrl: process.env.VUE_APP_API_URL,
      fields: [
        // A column that needs custom formatting
        { key: "name", label: "Navn" },
        // A regular column
        { key: "email", label: "E-postadresse" },
        // A virtual column made up from two fields
        { key: "phone", label: "Telefonnummer" },
        { key: "code", label: "Verdibevisnummer" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      dates: "bookings/availableDates",
      user: "auth/getUser",
    }),
  },
  components: {
    Calendar,
    List,
    DateModal,
    ChangeParticipantsForm,
    "booking-settings": BookingsSettings,
  },
  methods: {
    ...mapActions({
      getAvailableDates: "bookings/getAvailableDates",
    }),
    formatDate(date) {
      return format(parseISO(date), "Y-MM-dd HH:mm");
    },
    showBookings(date) {
      this.selectedDate = this.dates.find((d) => d.id === date.customData.id);
      this.selectedDate.rowData = date;
      this.$bvModal.show("bookingModal");
    },
    showBookingsFromList(date) {
      this.selectedDate = this.dates.find((d) => d.id === date.id);
      this.selectedDate.rowData = date;
      this.$bvModal.show("bookingModal");
    },
  },
};
</script>
